//react
import React from 'react';

//redux
//import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import IconButton from "@material-ui/core/IconButton";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";

// @material-ui/icons
import Location from "@material-ui/icons/LocationOn";
import SMS from "@material-ui/icons/SmsOutlined";


function Transition(props) {
    return <Slide direction="down" {...props} />;
  }
  
  class AlertEditor extends React.Component{
    constructor(props) {
      super(props);
      this.state = {
        modal: false
      };
    }

    handleClickOpen(modal) {
      var x = [];
      x[modal] = true;
      this.setState(x);
    }

    handleClose(modal) {
      var x = [];
      x[modal] = false;
      this.setState(x);
    }

    render() {

      const { classes } = this.props;

      return (
        <div>
          
          <IconButton
            aria-label="New Alert"
            onClick={() => this.handleClickOpen("modal")}>
            <SMS
                className={
                    classes.tableActionButtonIcon + " " + classes.edit
                }
                style={{color:"white"}}
            />
          </IconButton>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal
            }}
            maxWidth="md"
            fullWidth
            open={this.state.modal}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => this.handleClose("modal")}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">


            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{backgroundColor:"#efefef"}} >
              <h4 className={classes.modalTitle}>Create a New Alert</h4>
            </DialogTitle>
            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
              style={{backgroundColor:"#efefef"}}>
             <CustomTabs
                headerColor="success"
                tabs={[
                  {
                    tabName: "General",
                    tabIcon: Location,
                    tabContent: (
                      
                        <GridContainer direction="row">
                          
                            

                        </GridContainer>
                    )
                  },
                  
                ]}
              />

            </DialogContent>
            
            <DialogActions
              className={classes.modalFooter }
              style={{backgroundColor:"#efefef"}}>
              <Button
                onClick={() => this.handleClose("modal")}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                    
                    this.handleClose("modal");
                  }}
                color="success">
                Send
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  }
  
  const mapStateToProps = state => {
    return state;
  }

  AlertEditor = connect(mapStateToProps)(AlertEditor);
  export default withStyles(modalStyle)(AlertEditor);


// WEBPACK FOOTER //
// ./src/components/AlertEditor/AlertEditor.jsx